export const ACCESS_MODULES = [
  { key: "visits", label: "Visit Log", path: "/admin/log" },
  { key: "notes", label: "Notes", path: "/admin/notes" },
  { key: "files", label: "Files", path: "/admin/files" },
  { key: "clients", label: "Clients & Stay Log", path: "/admin/clients", careOnly: true },
];

const PATH_MODULE = [
  ["/admin/log", "visits"], ["/admin/notes", "notes"], ["/admin/files", "files"],
  ["/admin/clients", "clients"], ["/admin/stays", "clients"],
];

export const moduleForPath = (pathname) => PATH_MODULE.find(([p]) => pathname === p || pathname.startsWith(p + "/"))?.[1] || null;

/** "none" | "read" | "write" — admins always write, officers per granted permissions. */
export const STAFF_ROLES = ["officer", "staff", "teacher", "driver"];
export const isStaffRole = (user) => STAFF_ROLES.includes(user?.role);

export function accessLevel(user, module) {
  if (!user) return "none";
  if (["admin", "corporate_admin", "platform_owner"].includes(user.role)) return "write";
  if (isStaffRole(user)) return user.permissions?.[module] || "none";
  return "none";
}

export const officerAllowedModules = (user) => ACCESS_MODULES.filter((m) => accessLevel(user, m.key) !== "none");
export const officerHasConsole = (user) => isStaffRole(user) && officerAllowedModules(user).length > 0;

/** True when the current user may edit `module` (admins always; officers need "write"). */
export const canWriteModule = (user, module) => accessLevel(user, module) === "write";
